import { __assign, __read, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * @author Ivan Torres
 */
/* eslint @typescript-eslint/no-explicit-any: 0 */
import { useMemo } from 'react';
import * as React from 'react';
import cx from '../classNames';
import { useTheme } from '../theme';
import { omit$props } from '../helpers';
import _buildUtils from './_buildUtils';
import _parseStyle from './_parseStyle';
import useMemoizedStyletron from './useMemoizedStyletron';
var styled = function (ComponentOrTag) {
    var styleArgs = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styleArgs[_i - 1] = arguments[_i];
    }
    var StyledInit = React.forwardRef(function (props, ref) {
        var ctx = useTheme();
        var _a = __read(useMemoizedStyletron(), 1), styletronCSS = _a[0];
        var _b = props.className, className = _b === void 0 ? '' : _b, style = props.style, $style = props.$style, ownProps = __rest(props, ["className", "style", "$style"]);
        var Component = props.$as || ComponentOrTag;
        // NOTE: prepend previously generated classes by styletron, this can happen
        // when re-styling a component built with `styled` or `className` added
        // on top of it:
        var utils = _buildUtils(ctx, styletronCSS);
        var _c = __read(_parseStyle(utils, ownProps, [styleArgs, className, $style, style]), 2), styleObject = _c[0], invalidArgs = _c[1];
        var classNames = cx(invalidArgs, styletronCSS(styleObject));
        var componentProps = useMemo(function () { return omit$props(ownProps); }, [ownProps]);
        return _jsx(Component, __assign({}, componentProps, { className: classNames, ref: ref }), void 0);
    });
    StyledInit.displayName =
        typeof ComponentOrTag === 'string'
            ? "styled(".concat(ComponentOrTag, ")")
            : "styled(".concat(ComponentOrTag.displayName || ComponentOrTag.name || ComponentOrTag, ")");
    return React.memo(StyledInit);
};
export default styled;
